import React, {useEffect, useState} from 'react';
import CSVButton from "../components/deprecatedUikit/CSVButton/CSVButton";
import PartnerSubscriptionsMap from '../components/partner-subscriptions/PartnerSubscriptionsMap';
import {getAllPartnerSubscriptions} from '../components/partner-subscriptions/request/partner-subscription-requests';
import {SubscriptionsHeader} from '../components/partner-subscriptions/styles';
import {
  formatSubscriptionItem,
  formatSubscriptionItemsForCSV
} from '../components/partner-subscriptions/formatSubscriptions';
import SecurSpaceContainer from '../components/common/SecurSpaceContainer';
import moment from 'moment';
import {SecurSpaceReportContainer, SecurSpaceReportTitle} from "../components/common";

const PartnerSubscriptions = ({account}) => {
    const [subscriptions, setSubscriptions] = useState([]);

    useEffect(() => {
        getAllPartnerSubscriptions(account)
            .then(({body}) => {
                const formattedItems = body.map(item => formatSubscriptionItem(item));
                setSubscriptions(formattedItems)
            })
    }, [account])


    const reportName = `Supplier Subscriptions ${moment().format("MM/DD/YYYY hh:mm A")}`;

    return (
        <SecurSpaceContainer>
            <SecurSpaceReportContainer component='section'>
                <SubscriptionsHeader mt={4}>
                <SecurSpaceReportTitle>Supplier Subscriptions</SecurSpaceReportTitle>
                    <CSVButton
                        reportData={formatSubscriptionItemsForCSV(subscriptions)}
                        reportName={reportName}
                        title="Download Report"
                    />
                </SubscriptionsHeader>
                <PartnerSubscriptionsMap
                    subscriptions={subscriptions}
                />
            </SecurSpaceReportContainer>
        </SecurSpaceContainer>
    );
};

export default PartnerSubscriptions;
